function isTcpTurnUrl(url) {
  return typeof url === "string" && /[?&]transport=tcp(?:&|$)/i.test(url);
}

function filterExplicitIceServersForTcp(iceServers) {
  const tcpIceServers = iceServers
    .map(iceServer => {
      if (Array.isArray(iceServer.urls)) {
        const tcpUrls = iceServer.urls.filter(isTcpTurnUrl);

        return tcpUrls.length > 0 ? { ...iceServer, urls: tcpUrls } : null;
      }

      return isTcpTurnUrl(iceServer.urls) ? iceServer : null;
    })
    .filter(Boolean);

  return tcpIceServers.length > 0 ? tcpIceServers : iceServers;
}

export function resolveDialogIceServers({ host, turn, iceServers, forceTcp }) {
  if (Array.isArray(iceServers) && iceServers.length > 0) {
    return forceTcp ? filterExplicitIceServersForTcp(iceServers) : iceServers;
  }

  const resolvedIceServers = [];

  if (turn && turn.enabled) {
    turn.transports.forEach(ts => {
      if (!forceTcp) {
        resolvedIceServers.push({
          urls: `turns:${host}:${ts.port}`,
          username: turn.username,
          credential: turn.credential
        });
      }

      resolvedIceServers.push({
        urls: `turns:${host}:${ts.port}?transport=tcp`,
        username: turn.username,
        credential: turn.credential
      });
    });
    resolvedIceServers.push({ urls: "stun:stun1.l.google.com:19302" });
  } else {
    resolvedIceServers.push({ urls: "stun:stun1.l.google.com:19302" }, { urls: "stun:stun2.l.google.com:19302" });
  }

  return resolvedIceServers;
}
